/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { UserResetPswStep } from './enums';
import { Encrypt } from './base.models';

export class UserResetPswStepTwoRequest {
	public _step: UserResetPswStep;
	@Encrypt()
	public tempPass: string;
	public email: string;

	constructor(values: UserResetPswStepTwoRequest) {
		for (const [key, value] of Object.entries(values)) this[key] = value;
	}
}
